import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FaSyncAlt } from 'react-icons/fa';
import ApiEndpoints, { BASE_URL, BASE_URL_Upload } from './commonComponents/ApiEndpoints';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie'
import axios from 'axios';
import Image from 'react-bootstrap/Image'
import { useAuth } from './AuthContext'

const Certificate = () => {

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px'
  );

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const [courses, setCourses] = useState([])
    const [selectedCourseId, setSelectedCourseId] = useState('')
    const [selectedCourseName, setSelectedCourseName] = useState('')
  const [certificateData, setCertificateData]=useState("")
    const [selectedClass, setSelectedClass] = useState('')
  const [img, setImg] = useState(null)

  
    const [classes, setClasses] = useState([])
    const[allStududents, setAllStudents]=useState([])
    const [studentData, setStudentData] = useState({
      date: '',
      grade: '',
      certificateId: ''
    });    
    const [students, setStudents] = useState([])
    const [selectedStudent, setSelectedStudent] = useState('')
    const [selectedStudentInfo, setSelectedStudentInfo] = useState(null)
    const [showGenerateButton, setShowGenerateButton]= useState(true)
    const [errorMessageDuringGenerate, setErrorMessageDuringGenerate]=useState("")
    const [successMessageDuringGenerate, setSuccessMessageDuringGenerate]=useState("")
    const [instituteName, setInstitutename] = useState()
    
    const [openCertificate, setOpenCertificate] = useState(false)
    const [data, setData] = useState([])
    const {token} = useAuth()

    useEffect(()=>{
      const fetchAllStudent = async ()=>{
           try {
        const institueId = Cookies.get("institute_id")
        const userCookie = Cookies.get('user')

        if(!userCookie) {
          console.error("User cookie not found")
        }
        const user = JSON.parse(userCookie)
        const token = user.token

        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL + '/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)
        setAllStudents(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
      }
      fetchAllStudent()
    },[])

      useEffect(() => {
        const storedInstituteName = Cookies.get('institute_name')
    
        if (storedInstituteName) {
          console.log('Institute name:', storedInstituteName)
          setInstitutename(storedInstituteName)
        }
    
      }, [])
    

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => {
        console.log('Courses', res.data.data)
        setCourses(res.data.data)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (selectedCourseId) {
      ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            setClasses([])
          } else {
            setClasses(data.data)
            // setSelectedClass(classId)
          }
        })
        .catch(() => {
          setClasses([])
        })
    }
  }, [selectedCourseId])



    const handleCourseChange = async (e) => {
      const courseId = e.target.value
      setSelectedCourseId(courseId)
      console.log("Selected Course Id:", courseId)
      // setClasses([])
      // setFilteredStudents([])
      // setSelectedData([])
  
      if(courseId){
        const courseName = courses.find((c)=>c.id === Number(courseId))
        setSelectedCourseName(courseName)
      }
      if (courseId) {
        const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
        setClasses(res.data.data)
      }
      if (courseId) {
        ApiEndpoints.getAllClassesByCourseId(courseId)
          .then((res) => {
            const { data } = res
            if (data.status === false || !data.data?.length) {
              toast.error('No classes found for this course.')
              setClasses([])
              // setOpenTable(false)
            } else {
              setClasses(data.data)
            }
          })
          .catch((error) => {
            // This is where 404 or other errors come
            if (
              error.response?.data?.message === 'No classes found for this course'
            ) {
              toast.error('No classes found for this course.')
            } else {
              console.error('Error fetching classes:', error)
              toast.error('Something went wrong while fetching classes.')
            }
            setClasses([])
          })
      }
    }
    const handleClassChange = (e) => {
      // setHasModifiedFields(true)
      const classId = e.target.value
      console.log(' Targeted classId', classId)
      setSelectedClass(classId)

  
      if (classId) {
        const institueId = Cookies.get('institute_id')
        const headers = {
          institute_id: Number(institueId),
        }
        axios
          .get(
            BASE_URL + `/get/student/by-class?class_id=${classId}`,
            { headers },
          )
          .then((res) => {
            console.log('Students after class select:', res.data.data)
            setData(res.data.data)
            setStudents(res.data.data)
            // setAllStudents(res.data.data)
          })
          .catch((error) => {
            // This is where 404 or other errors come
            if (
              error.response?.data?.message === 'No classes found for this course'
            ) {
              console.error('No classes found for this course.')
            } else {
              console.error('Error fetching classes:', error)
              console.error('Something went wrong while fetching classes.')
            }
            setClasses([])
          })
      }
    }


    toast.warning = (message) =>
  toast(message, {
    icon: '⚠️',
    style: {
      background: '#ff9800ow',
      color: 'black',
    },
  });

  const handleStudentChange = async (e) => {
    const studentId = e.target.value;
    setSelectedStudent(studentId);
  
    setOpenCertificate(false)
    setErrorMessageDuringGenerate(null)
    setShowGenerateButton(true)
    // Partial info (used for display, like name, class, etc.)
    const studentInfo = data.find((s) => s.id === Number(studentId));
    setSelectedStudentInfo(studentInfo);
    console.log('Selected student info:', studentInfo);
  
    // Full info (used to get admission_date)
    const fullInfo = allStududents.find((s) => s.id === Number(studentId));
    setImg(fullInfo)
    console.log('Full student info :', fullInfo);
      console.log('Full student info with father_name:', fullInfo?.father_name);
setCertificateData(fullInfo)
    if (fullInfo && fullInfo.admission_date) {
      // Format admission_date → 'YYYYMMDD'
      const rawDate = new Date(fullInfo.admission_date);
      // const datePart = rawDate.toISOString().slice(0, 10).replace(/-/g, ''); // e.g., '20250412'
  
      const datePart = rawDate.getFullYear()
      const coursePart = selectedCourseId || '00';
      const certificateId = `${datePart}/${coursePart}/${fullInfo.id}`;
  
      setStudentData({
        ...fullInfo, // Or use studentInfo if you prefer other display fields
        certificateId: certificateId,
        date: new Date().toLocaleDateString(), // today's date
        grade: fullInfo.grade || 'A',
      });
    } else {
      console.error('Admission date is not available for the selected student.');
    }
  
    // setOpenCertificate(true);
  };

//   const handleGenerateCertificate = async()=>{
//     if(!selectedCourseId){
//   toast.error("Please select a course before generating certificate.")
//   return 
// }

// try {


//   const checkResponse = await axios.get(`https://ttaapi.vibhumsoftware.com/api/certificate?student_id=${selectedStudent}&course_id=${selectedCourseId}`,
//      {
//       headers:{
//         Authorization:`Bearer ${token}`
//       }
//      })

//     console.log("Checking response of Certificate:", checkResponse)
//   const response = await axios.post( "https://ttaapi.vibhumsoftware.com/api/generate-certificate",{
//     student_id:selectedStudent,
//     course_id:selectedCourseId
//   },{
//     headers:{
//        "Content-Type": "application/json",
//        Authorization:`Bearer ${token}`
//     }
//   })
  
//   console.log(response.data)
//   if (
//         response.status === 201 &&
//         response.data.message === "Certificate generated successfully"
//       ) {
//         toast.success(response.data.message);
//         // keep button hidden after success
//         setShowGenerateButton(false);
//         setOpenCertificate(true)
//         setErrorMessageDuringGenerate(null)
//       } else if (
//         response.status === 200 &&
//         response.data.message === "Certificate already generated"
//       ) {
//         toast.warning(response?.data?.message);

//         setOpenCertificate(true)
//         setShowGenerateButton(false);
//         setErrorMessageDuringGenerate(null)
//       }
//       } catch (error) {
//         setErrorMessageDuringGenerate(error.response?.data?.error)
//         setOpenCertificate(false)
//       }
//     }

const handleGenerateCertificate = async () => {
  if (!selectedCourseId) {
    toast.error("Please select a course before generating certificate.");
    return;
  }

  try {
    const response = await axios.post(
      BASE_URL + "/generate-certificate",
      {
        student_id: selectedStudent,
        course_id: selectedCourseId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response while triger generate certificate button", response?.data)

    toast.success(response.data.message)
    // const {message, certificate, student, course, institute} = response.data

    // if (response.status===201 || response.data?.message === "Certificate generated successfully") {
    //   toast.success( response.data?.message );
    //   setOpenCertificate(true);
    //   setShowGenerateButton(false);
    // } else if (response.data.status===200 || response.data?.message === "Certificate already generated") {
    //   toast.info(response.data?.message );

    //   setShowGenerateButton(false); // Hide generate button
    // }
  } catch (error) {
    toast.error(error.response?.data?.error || "Something went wrong");
  }
};

const handleViewCertificate = async () => {
  if (!selectedCourseId) {
    toast.error("Please select a course before viewing certificate.");
    return;
  }

  try {
    const response = await axios.get(
      BASE_URL + `/certificate?student_id=${selectedStudent}&course_id=${selectedCourseId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Certificate details fetched :", response.data)
    

      setCertificateData({
        certificate: response.data.certificate,
        student: response.data.student,
        course: response.data.course,
        institute: response.data.institute,
      });

      setOpenCertificate(true);
      setShowGenerateButton(false);
  } catch (error) {
    toast.error("Certificate not found. Please generate first.");
  }
};



  const handleRefresh = () => {
    setSelectedCourseId(null)
    setSelectedClass(null)
    setSelectedStudent(null)
    setData([])
    setOpenCertificate(false)
    setErrorMessageDuringGenerate(null)
  }

  // const studentName = "Bal Krishna"

  const spanStyle={
    width:"100%",
      borderBottom: "1px solid black",
      // minWidth: "390px",
      display: "flex",
      justifyContent: "space-between",
      // alignItems: "center",
      // fontWeight: "bold",
      // marginLeft: "1rem",
      // paddingBottom: "2px",
  }
  return (
    <>
      <style>
        {`
        
    /* Watermark styles */
      .certificate-border {
        position: relative;
        background-color: white;
        overflow: hidden;
      }

.watermark-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  opacity: 0.8; /* adjust as needed */
  z-index: 0;
  pointer-events: none;
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

.watermark-logo-wrapper img {
  width: 200%;       /* increase width only */
  height: auto;      /* keep height proportional */
  max-width: none;   /* prevent automatic limiting */
}


      /* Content stays above watermark */
      .certificate-content > * {
        position: relative;
        z-index: 1;
      }

          @media print {
            body * {
              visibility: hidden;
            }
                .title-underline {
    display: block !important;
    height: 3px !important;
    background-color: #f1c40f !important;
    margin: 10px auto !important;
      border-bottom: 2px solid #f1c40f;
  }

            .certificate-printable, .certificate-printable * {
              visibility: visible;
            }
            .certificate-printable {
              position: absolute;
              left: 0;
              top: -1.6rem;
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
            }
        //         .watermark-logo-wrapper {
        //   opacity: 13 !important;
        //   width: 100% !important;
        // }
        
//         @media print {
//   .certificate-border {
//     border: 25px solid #4a6da7 !important;
//     background-color: white !important;
//     box-shadow: none !important;
//     print-color-adjust: exact;
//     -webkit-print-color-adjust: exact;
//     color-adjust: exact;
//   }

//   /* Ensure the wrapper is visible */
//   .certificate-wrapper {
//     visibility: visible !important;
//     position: relative !important;
//     print-color-adjust: exact;
//     -webkit-print-color-adjust: exact;
//   }
// }


            @page {
              size: auto;
              margin: 0mm;
            }
          }
          .certificate-wrapper {
            max-width: 1200px;
            margin: 0 auto;
            //  width: 100%;
            // height: 100%;
            // overflowX:hidden;
            position: relative;
          }
          .certificate-border {
            background-color: white;
            border: 15px solid #4a6da7;
            position: relative;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
             print-color-adjust: exact;
          // -webkit-print-color-adjust: exact;
          // color-adjust: exact;
          }
          .corner {
            position: absolute;
            width: 50px;
            height: 50px;
          }
          .corner-tl {
            top: -3px;
            left: -5px;
          }
          .corner-tr {
            top: -5px;
            right: -5px;
            transform: rotate(90deg);
          }
          .corner-bl {
            bottom: -5px;
            left: -5px;
            transform: rotate(270deg);
          }
          .corner-br {
            bottom: -5px;
            right: -5px;
            transform: rotate(180deg);
          }
          .certificate-title {
            font-family: 'Times New Roman', serif;
            font-weight: bold;
            color: #2c3e50;
            font-size: 2.3rem;
            position: relative;
            display: inline-block;
          }
          .title-underline {
            width: 100px;
            height: 3px;
            background-color: #f1c40f;
            margin: 10px auto;
          }
          .student-name {
            // font-family: 'Brush Script MT', cursive;
            font-family: 'Lora', serif;
            font-weight: bold;
            font-size: 2.5rem;
            color: #2c3e50;
            margin: 1rem 0;
            position: relative;
            display: inline-block;
          }

           .student-name::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 2px;
            background: linear-gradient(90deg, transparent, #f1c40f, transparent);
    display: block;
    visibility: visible;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  
          .certificate-description {
            max-width: 700px;
            font-size: 1.6rem;
            line-height: 1;
          }
          .detail-item {
            // margin-bottom: 0.5rem;
          }
          .detail-label {
            font-weight: bold;
            margin-right: 0.5rem;
          }
          .signature-line {
            // width: 200px;
            // height: 1px;
            // background-color: #333;
            // margin: 0 auto;

              border-top: 1px solid #000;
  width: 150px;
  margin: 0 auto 8px auto;
          }
          .signature-name {
            font-weight: bold;
            margin-top: 10px;
          }

          
  
 
            
          .institution-logo img {
            border-radius: 50%;
            // border: 2px solid #f1c40f;
            // padding: 5px;
          }
          .print-button {
            background-color: #2c3e50;
            border: none;
            padding: 10px 25px;
            font-weight: bold;
          }
          .print-button:hover {
            background-color: #1a252f;
          }
          @media (max-width: 768px) {
            .certificate-title {
              font-size: 2rem;
            }

              
            .student-name {
              // font-size: 2.5rem;
            }
            .certificate-border {
              border-width: 10px;
            }
            .corner {
              width: 40px;
              height: 40px;
            }
          }
          @media (max-width: 576px) {
            .certificate-title {
              font-size: 1.8rem;
            }
            .student-name {
              font-size: 2rem;
            }
            .certificate-description {
              font-size: 1rem;
            }
            .signature-line {
              width: 150px;
            }
          }
 
       @media print {
  // .certificate-content img,
  // .certificate-content svg,
  // .certificate-content text {
  //   visibility: visible !important;
  // }

        // .certificate-border {
        //     background-color: white;
        //     border: 17px solid #4a6da7;
        // }

  .certificate-content svg {
    // display: inline !important;
    margin-left: 2rem !important;
    width:650px !important;
    margin-top:-4rem !important;
  }
    .certificate-content .img-tta{
          margin-left:0rem !important;
          margin-top:-1rem !important;
    }
 
           .certificate-content .img-style{
          // margin-right:2rem !important;
          margin-top:-2rem !important;
    }
    .certificate-content text{
    font-size:20px !important;
    margin-bottom:13rem !important;
    }
}
@media print {
  .gof-nct {
    background-color: #4a6da7 !important;
    color: white !important;
    font-style: italic;
    font-size: 18px !important;
    border-radius: 2px !important;
    width: 70% !important;
    margin-top:5.3rem !important;
    margin-left: 6.5rem !important;
    // padding: 2px !important;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

.logo-box{
margin-top:13.5rem !important;
}
      .img-nct {
      margin-top:1rem !important;
            border-radius: 50%;
            // border: 2px solid #f1c40f;
            // padding: 5px;
              height: 90px !important;  /* smaller in print */
            width: 90px !important;
          }
      .gvt{
      font-size:8px !important;
      }
}

@media print {
  .row-signatures {
    margin-top: 4.7rem !important;
    margin-bottom: -2rem !important;
  }
}


        `}
      </style>

      <div style={{ marginLeft }}>
        {/* Non-printable controls */}
        <div className="no-print">
          <div className="container-fluid p-0"
            style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}>
            <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
              <h2 className="m-0">Generate Certificate</h2>
            </div>
          </div>

          <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
            <Col md={3}>
              <Form.Group className="text-start fw-bold mb-0">
                <Form.Label>Select Course</Form.Label>
                <Typeahead
                  id="course-select"
                  labelKey="name"
                  onChange={(selected) => {
                    const course = selected[0]
                    if (course) {
                      handleCourseChange({ target: { value: course.id } })
                    } else {
                      handleCourseChange({ target: { value: '' } })
                    }
                  }}
                  options={courses}
                  placeholder="Select Course"
                  selected={courses.filter(
                    (cs) => cs.id === Number(selectedCourseId || ''),
                  )}                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="text-start fw-bold mb-0">
                <Form.Label>Select Class</Form.Label>
                <Typeahead
                  id="class-select"
                  labelKey="class_name"
                  onChange={(selected) => {
                    const cls = selected[0]
                    if (cls) {
                      handleClassChange({ target: { value: cls.id } })
                    } else {
                      handleClassChange({ target: { value: '' } })
                    }
                  }}
                  options={classes}
                  placeholder="Select Class"
                  selected={classes.filter(
                    (cs) => cs.id === Number(selectedClass || ''),
                  )}                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="text-start fw-bold">
                <Form.Label>Select Student</Form.Label>
                <Typeahead
                  id="student-select"
                  labelKey={(option) =>
                    `${option.name} - ${option.admission_number}`
                  }
                  onChange={(selected) => {
                    const student = selected[0]
                    if (student) {
                      handleStudentChange({ target: { value: student.id } })
                    } else {
                      handleStudentChange({ target: { value: '' } })
                    }
                  }}
                  options={students}
                  placeholder="Select Student"
                  selected={
                    Array.isArray(students)
                      ? students.filter(
                          (s) => s.id === Number(selectedStudent || ''),
                        )
                      : []
                  }
                />
              </Form.Group>
            </Col>
            <Col className="d-flex justify-content-end">
              <Button
                variant="outline-primary"
                title="Refresh"
                className="mt-3" onClick={handleRefresh}
              >
              Refresh
              </Button>
            </Col>
            {selectedStudent &&  (
             <Row>
    <Col className="d-flex align-items-end justify-content-space-between flex-grow-1 gap-4 mt-3">
             {showGenerateButton && (
                <Button className='btn-btn-success print-button' 
                onClick={handleGenerateCertificate}
                >
                  Generate Certificate
                </Button>
             )}
              <Button
                  className="btn btn-primary"
                  onClick={handleViewCertificate}
                >
                  View Certificate
                </Button>
                <Button 
               className="btn btn-primary print-button"
               onClick={() => window.print()}
             >
               Print Certificate
             </Button>
                </Col>
            </Row>
            )}
           {/* {selectedStudent  && (
           
             <Button 
               className="btn btn-primary print-button"
               onClick={() => window.print()}
             >
               Print Certificate
             </Button>
          
           )} */}
          </Row>
        </div>

    {openCertificate && selectedStudent &&  (
        
        <div className="certificate-printable">
            
          <div className="certificate-wrapper mt-4">
            
            <div className="certificate-border ">
              <div className="watermark-logo-wrapper">
                <img 
                  src="/certWatermark.jpg" 
                  alt="Watermark Logo" 
                  className="watermark-logo" 
                />
              </div>
              <div className="corner corner-tl"></div>
              <div className="corner corner-tr"></div>
              <div className="corner corner-bl"></div>
              <div className="corner corner-br"></div>
              
              <div className="certificate-content p-4 p-md-5">
              
              
                    <div className="d-flex justify-content-between align-items-center">
                        <img 
                          src="/tta_logobg.png" 
                          alt="Institution Logo" 
                          className="img-tta"
                          style={{ width: '100px',height:'100px' }}
                        />
                           {/* <Image
                            className="img-style"
                            src={
                              img?.student_image
                                ? img.student_image.replace(
                                    'https://ttaapi.vibhumsoftware.com/storage/student/',
                                    'https://ttaapi.vibhumsoftware.com/student/images/student/',
                                  )
                                : '/studentprofile.jpg'
                            }
                            style={{
                              width: '120px',
                              height: '120px',
                              border: '1px solid black',
                              background: 'white',
                            }}
                            onLoad={() => console.log('Image loaded')}
                          /> */}
                          <div className='text-center'>
                          <img 
                            src="/nct_logo2.png" 
                            alt="NCT Logo" 
                            className="img-nct"
                            style={{ width: '100px',height:'100px' }}
                          />
                           <div className='gvt' style={{ fontSize: '10px', fontWeight: 'bold', marginTop: '4px' }}>
                            GOVERNMENT OF NCT OF DELHI
                          </div>
                          </div>
                    </div>
  <div style={{ position: 'relative', 
  marginTop: -400,marginLeft:-40,
     width: "100%", height: "200px",  }}>
    <svg width="900" height="1200" viewBox="0 0 430 150" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          id="curve"
          d="M 35 125 A 200 250 0 0 1 420 125"
          fill="transparent"
        />
      </defs>
      <text fill="#2c3e50" fontSize="19px" fontWeight="bold">
        <textPath href="#curve" startOffset="50%" textAnchor="middle">
          {/* {instituteName?.toUpperCase()} */}
        {certificateData.institute?.institute_name?.toUpperCase()}
        </textPath>
      </text>
    </svg>
  </div>

  {/* <img 
    src="/nct_logo.png" 
    alt="NCT Logo" 
    className="img-nct"
    style={{ width: '120px' }}
  /> */}
                     
              {/* <div style={{marginTop:200}}>
                 <img 
                    src="/education-logo2.png" 
                    alt="NCT Logo" 
                    // className="img-nct"
                    style={{ width: '150px', }}
                  />               
              </div> */}

                <div style={{ marginTop: 250, display: 'flex', flexDirection: 'column', alignItems: 'center',marginBottom:"-2rem"}} className='logo-box'>
                  <img 
                    src="/education-logo3.png" 
                    alt="Education Logo" 
                    style={{ width: '100px' }} 
                  />

                  {/* <img
                    src="/nielit.png"
                    alt="NIELIT Logo"
                    style={{ width: '130px', height: '130px' }}
                  /> */}
                </div>

                <div className='gof-nct' style={{backgroundColor:"#4a6da7", color:"white", width:"50%" , fontSize:"20px", borderRadius:"2px", marginTop:85, marginLeft:280}}> 
                    <p style={{padding:5}}>Project Plan Conducted By Government of NCT of Delhi</p>
              </div>
                 <div className="text-center mb-3 pt-4 powered-by-footer" style={{marginTop:-40}}>
                  <small className="fw-bold powered" style={{ fontStyle: 'italic', fontSize: '14px', color:"#", }}>
                 Tera Tujko Arpan (ISO 9001 : 2015)
                </small>
                 <p className="fw-bold powered" style={{ fontSize: '14px', color:"#",letterSpacing:"1px", fontStyle: 'italic', }}>
                 UDYAM-DL-10-0079981
                </p>
              </div> 
                <div className="text-center" style={{ marginTop: -10,  }}>
                  <h2 className="certificate-title" style={{}}>Certificate of Achievement</h2>
                  <div className="title-underline mx-auto"></div>
                  <p style={{fontWeight:"600"}}>This Certificate is Awarded To</p>
                </div>
            <div
  className="certificate-header"
  style={{
    marginBottom: "50px",
    // marginTop: -1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position:"relative",
  }}
>

  {/* Center: Student Name */}
  <div style={{ 
    position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      width: "max-content", }}>
    <h2
      className="student-name"
      style={{ margin: 0, fontSize: "32px", fontWeight: "bold" }}
    >
      {certificateData?.student?.name}
    </h2>
  </div>

  {/* Right: Student Image */}
  <div style={{ flex: 1, textAlign: "right", }}>
    <Image
      className="img-style"
      src={
        certificateData?.student?.student_image
          ? certificateData.student.student_image.replace(
              BASE_URL_Upload+ "/storage/student/",
              BASE_URL_Upload+ "/student/images/student/"
            )
          : "/studentprofile.jpg"
      }
      alt="Student"
      style={{
        width: "70px",
        height: "70px",
        border: "1px solid black",
        background: "white",
        objectFit: "cover",
      }}
    />
  </div>
</div>

     {/* Left: Certificate Number */}
  <div style={{ flex: 1, textAlign: "left" ,
    fontWeight:"bold"}}>
    <p style={{ marginTop:"-2rem", marginBottom:"2rem", fontSize: "14px" }}>
      Certificate Number:{" "}
      <strong>{certificateData?.certificate?.certificate_number}</strong>
    </p>
  </div>         
              <div className="certificate-details text-start" style={{   fontWeight:"bold"
              }}>
         <p style={{ display: "flex", alignItems: "center" }}>
          This certificate is awarded to
          <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>
            {certificateData?.student?.name || "\u00A0"}
          </span>
        </p>
      


              {/* <p>
                Son/Daughter of{" "}
                <span
                  style={{...spanStyle, minWidth:"460px"}}
                >
                  {certificateData.mother_name || "_______________________________"}
                </span>(Mother)
              </p> */}
              <p style={{ display: "flex", alignItems: "center" }}>
  Son/Daughter of{" "}(Father)
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.student?.father_name || "\u00A0"}
  </span>
</p>

              {/* <p>
                and{" "}
                <span
                  style={{...spanStyle, minWidth:"560px"}}
                >
                  {certificateData.father_name || "__________________________"}
                </span>(Father)
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                and{" "}(Mother)
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.student?.mother_name || "\u00A0"}
  </span>
</p>

              {/* <p>
                 Admission number{" "}
                <span
                  style={{...spanStyle, minWidth:"320px"}}
                >
                  {selectedStudentInfo.admission_number || "__________________________"}
                </span>{" "}having completed the 
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                 Admission number{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.student?.admission_number || "\u00A0"}
  </span>
</p>
                {/* <p>
                Course on{" "}
                <strong> {selectedCourseName?.name} </strong>
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                Course on{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    {certificateData?.course?.course_name || "\u00A0"}
  </span>
</p>
               {/* <p>
                during{" "}
                <span
                  style={{...spanStyle, minWidth:"430px"}}
                >
                  {" " || "__________________________"}
                </span>
              </p> */}
              <p style={{ display: "flex", alignItems: "center" }}>
                during{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" , marginTop: "0px"}}>   
   {new Date(certificateData.course.start_date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })} -{" "}
    {new Date(certificateData.course.end_date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }) || "\u00A0"}
  </span>
</p>
               {/* <p>
                The candidate is sponsored by{" "}
                <span
                  style={{...spanStyle, minWidth:"430px"}}
                >
                  {instituteName || "__________________________"}
                </span>
              </p> */}
  <p style={{ display: "flex", alignItems: "center" }}>
                The candidate is sponsored by{" "}
<span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>    { certificateData?.institute?.institute_name || "\u00A0"}
  </span>
</p>
               {/* <p>
                 Candidate has been awarded{" "}
                <span
                  style={{...spanStyle, minWidth:"320px"}}
                >
                  {" " || "__________________________"}
                </span>{" "}Grade 
              </p> */}
             <p style={{ display: "flex", alignItems: "center" }}>
  Candidate has been awarded{" "}
  <span
    style={{
      flex: 1,
      borderBottom: "1px solid black",
      marginLeft: "8px",
      fontWeight: "bold",
      justifyContent: "center",
      display: "flex",
      marginTop: "18px"
    }}
  >
    {" " || "\u00A0"}
  </span>{" "}
  Grade
</p>

              </div>           
                
            <div
  className="row signatures row-signatures"
  style={{
    marginTop: "94px",
    marginBottom: "-1.8rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    fontWeight:"bold"
  }}
>
  {/* Left: Issue Date */}
  <div style={{ flex: 2, textAlign: "left", }}>
    <p className="mb-0">Date of issue:</p>
    <p className="fw-bold">{certificateData?.certificate?.issue_date}</p>
  </div>

  {/* Center: Instructor */}
  <div style={{ flex: 7,  textAlign: "center" }}>
    <div className="signature-line mb-1"></div>
    <p className="mb-0">Instructor</p>
    <p className="signature-name">Authorized Signatory</p>
  </div>

  {/* Right: Director */}
  <div style={{ flex: 2, textAlign: "center" }}>
    <div className="signature-line mb-1"></div>
    <p className="mb-0">Director</p>
    <p className="signature-name">Authorized Signatory</p>
  </div>
            </div>

              </div>
                {/* <div className="text-center mt-0 mb-3 pt-4 powered-by-footer">
                  <small className="text-muted powered" style={{ fontStyle: 'italic', fontSize: '14px' }}>
                  Powered by <strong className='text-danger'>Tera Tujhko Arpan (ISO 9001 : 2015)</strong>
                </small>
              </div> */}
            </div>
          </div>
        </div>
        
    )}


    {errorMessageDuringGenerate  && !openCertificate && (
      <p className='text-danger fw-semibold mt-4'>{"There is no certificate available for this student. " +  errorMessageDuringGenerate}</p>
    )}
      </div>

    </>
  );
};

export default Certificate;


